import dateTimeWrapper from "./templates/datetime/wrapper.html";
import dateOnlyWrapper from "./templates/datetime/dateOnlyWrapper.html";
import {
	dateTimeAddOn, 
	dateOnlyAddOn 
} from "./templates/datetime/datetime-add-on.js";

export default angular.module("vesl.extensions.json-schema.datetime", [
	"schemaForm"
])
	.run(["$templateCache", function($templateCache) { 
		$templateCache.put("./templates/datetime/wrapper.html", dateTimeWrapper); 
		$templateCache.put("./templates/datetime/dateOnlyWrapper.html", dateOnlyWrapper); 
	}])
	.config(dateTimeAddOn)
	.config(dateOnlyAddOn)
	.name;
